/** @jsxImportSource @emotion/react */
import { AIResponse, Box, Button, Icon, Text } from '@landtrustinc/design-system';
import React from 'react';

import type { BackpressureMessage } from '../../types';
import { containerStyles, iconStyles, statusStyles } from './styles';

type BackpressureProps = {
  msg: BackpressureMessage;
  isConsecutiveAssistant?: boolean;
  retryLastMessage: () => void;
};

const Backpressure: React.FC<BackpressureProps> = ({
  msg,
  isConsecutiveAssistant = false,
  retryLastMessage,
}) => {
  return (
    <AIResponse
      key={msg.id}
      showDisclaimer={false}
      showHelpfulQuestion={false}
      showTitle={!isConsecutiveAssistant}
    >
      <Box css={containerStyles}>
        {/* Warning icon */}
        <Box css={iconStyles}>
          <Icon variant="InfoCircle" size="medium" />
        </Box>

        {/* Message */}
        <Box mt="var(--spacing-2)">
          <Text size="md" fontWeight="semibold">
            {msg.backpressureMessage}
          </Text>
        </Box>

        {/* Retry suggestion */}
        <Box mt="var(--spacing-3)" css={statusStyles}>
          <Text size="sm" color="var(--text-secondary)">
            Please try again in {msg.retryAfter} seconds.
          </Text>
        </Box>

        {/* Retry button */}
        <Box mt="var(--spacing-3)">
          <Button size="sm" variant="secondary" onClick={retryLastMessage}>
            Try Again
          </Button>
        </Box>
      </Box>
    </AIResponse>
  );
};

export default Backpressure;
